// QuiSommesNous.js
import React from 'react';
import './PageContainer.css';


function QuiSommesNous() {
  return (
    <div className="page-container">
      <h1>Qui sommes-nous ?</h1>
      <p>
        Cabinet immobilier et de Consultance Juridique (CICJ IMMO) est un cabinet sénégalais basé à Thiès,
        avec une présence active à Dakar. Nous mettons notre expertise au service de vos projets immobiliers et
        juridiques grâce à une équipe pluridisciplinaire, réactive et engagée.
      </p>
      <h2>Nos domaines d’intervention :</h2>
      <ul>
        <li>Gérance immobilière</li>
        <li>Vente et location de biens</li>
        <li>Études techniques & expertises</li>
        <li>Consultance juridique</li>
        <li>Projets BTP (conception, construction, rénovation)</li>
      </ul>
      <p><strong>Notre mission :</strong> vous accompagner avec rigueur, transparence et efficacité dans la gestion, l’acquisition ou la valorisation de votre patrimoine.</p>
    </div>
  );
}

export default QuiSommesNous;
